import '@operato/dataset/ox-data-entry-view.js'

import gql from 'graphql-tag'
import { css, html, LitElement } from 'lit'
import { customElement, property, query, state } from 'lit/decorators.js'

import { client } from '@operato/graphql'
import { i18next, localize } from '@operato/i18n'
import { ScrollbarStyles } from '@operato/styles'
import { DataSet } from '@operato/dataset'

@customElement('activity-data-collect-view')
export class DataCollectActivityView extends localize(i18next)(LitElement) {
  static styles = [
    ScrollbarStyles,
    css`
      :host {
        display: flex;
        flex-direction: column;

        background-color: var(--md-sys-color-surface);
      }

      ox-data-entry-view {
        flex: 1;
        padding: 10px;
        overflow: auto;
      }

      @media print {
        :host {
          display: block;
          overflow: visible;
        }
      }
    `
  ]

  @property({ type: Object }) input?: any
  @property({ type: Object }) output?: any

  @state() dataSet?: DataSet & { id: string }

  render() {
    return html` <ox-data-entry-view .dataSet=${this.dataSet} .value=${this.output}></ox-data-entry-view>`
  }

  updated(changes) {
    if (changes.has('input')) {
      this.fetchDataSet()
    }
  }

  async fetchDataSet() {
    const id = this.input.dataSetId

    if (id) {
      const response = await client.query({
        query: gql`
          query ($id: String!) {
            dataSet(id: $id) {
              id
              name
              description
              useCase
              dataItems {
                name
                description
                active
                hidden
                tag
                group
                type
                unit
                options
                quota
                spec
                stat
              }
            }
          }
        `,
        variables: {
          id
        }
      })

      this.dataSet = response.data.dataSet
    }
  }
}
